<template>
  <div class="dropdown-wrapper">
    <label v-if="label" class="input-label">{{ label }}</label>
    <div
      class="select-container"
      :class="{
        error: error,
        disabled: disabled,
      }"
    >
      <select
        :value="modelValue"
        @change="
          $emit('update:modelValue', ($event.target as HTMLSelectElement).value)
        "
        :disabled="disabled"
        class="select-field"
      >
        <option value="" disabled selected>{{ placeholder }}</option>
        <option v-for="(option, index) in options" :key="index" :value="option">
          {{ option }}
        </option>
      </select>
      <div class="select-arrow">▼</div>
    </div>
    <div v-if="error && errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string;
  options: string[];
  label?: string;
  placeholder?: string;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
}>();

defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.dropdown-wrapper {
  width: 100%;
}

.input-label {
  font-size: 14px;
  margin-bottom: 4px;
  color: $pj-color-cool-gray;
}

.select-container {
  position: relative;
  border: 1px solid $pj-color-light-gray;
  border-radius: 11px;
  background-color: white;

  &.error {
    border-color: $pj-color-red;
  }

  &.disabled {
    opacity: 0.5;
    background-color: rgba($pj-color-light-gray, 0.1);
  }
}

.select-field {
  width: 100%;
  height: 50px;
  padding: 5px 20px;
  border: none;
  background: transparent;
  appearance: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.select-arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: $pj-color-cool-gray;
  pointer-events: none;
}

.error-message {
  color: $pj-color-red;
  font-size: 12px;
  margin-top: 4px;
}
</style>
